
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import GFunc from "@/utils/gFunc";
import Pagination from "@/comp/Pagination/index.vue";
import { propStickerList, propStickerSave, propStickerRemove } from "@/api/request/item";
import { getAppBaseApi, getHeaders } from "@/api/request";
import { Message } from "element-ui";

//组件
@Component({
  name: "PropStickerList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //定义变量
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //临时参数
    prop_id_str: "",

    //上传数据
    name: "",
    prop_id: 0,
  };

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.prop_id = Number(this.listQuery.prop_id_str);

    //获取数据
    const { data } = await propStickerList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理创建
  private handleCreate(): void {
    //数据赋值
    this.picUrl = null;
    this.picFileList = [];
    this.addForm = {
      //临时数据
      sort_str: "",
      prop_id_str: "",

      //参数
      id: 0, //ID
      sort: 0, //排序
      image: "", //图片地址
      prop_id: 0, //表情包ID

      //多语言名称
      name_list: {
        zh: "", //中文
        tw: "", //繁体
        en: "", //英语
        id: "", //印尼语
      },
    };
    this.dialogStatus = "create";

    //显示对话框
    this.dialogVisible = true;
  }

  //处理编辑
  private handleEdit(row: any): void {
    //数据赋值
    this.picUrl = null;
    this.picFileList = [];
    this.addForm = {
      //临时数据
      sort_str: String(row.sort),
      prop_id_str: String(row.prop_id),

      //参数
      id: row.id, //ID
      sort: row.sort, //排序
      image: row.image, //图片地址
      prop_id: row.prop_id, //表情包ID

      //多语言名称
      name_list: {
        zh: row.name_list.zh ? row.name_list.zh : "", //中文
        tw: row.name_list.tw ? row.name_list.tw : "", //繁体
        en: row.name_list.en ? row.name_list.en : "", //英语
        id: row.name_list.id ? row.name_list.id : "", //印尼语
      },
    };
    this.dialogStatus = "update";
    if (GFunc.checkstring(row.image)) {
      this.picUrl = GFunc.checkstring(row.image);
      this.picFileList.push({ name: "name.jpg", url: GFunc.checkstring(row.image) });
    }

    //显示对话框
    this.dialogVisible = true;
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    this.$confirm(`您确定要删除该表情包贴图？`, "警告", {
      confirmButtonText: this.$t("permission.confirm") as string,
      cancelButtonText: this.$t("permission.cancel") as string,
      type: "warning",
    })
      .then(async () => {
        //删除表情包贴图
        const res = await propStickerRemove({ id: row.id });

        //重新获取列表
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //--------------------------------- 添加/编辑 ---------------------------------
  //定义变量
  private dialogStatus: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private titleMap: any = { update: "修改表情包贴图", create: "新增表情包贴图" };

  //添加表单
  private addForm: any = {
    //临时数据
    sort_str: "",
    prop_id_str: "",

    //参数
    id: 0, //ID
    sort: 0, //排序
    image: "", //图片地址
    prop_id: 0, //表情包ID

    //多语言名称
    name_list: {
      zh: "", //中文
      tw: "", //繁体
      en: "", //英语
      id: "", //印尼语
    },
  };

  //创建
  private async createData() {
    //判断显示
    if (this.picUrl == "") return Message({ message: "请选择表情包贴图图片", type: "error", duration: 5 * 1000 });
    if (Number(this.addForm.sort_str) == 0) return Message({ message: "请输入排序！", type: "error", duration: 5 * 1000 });
    if (Number(this.addForm.prop_id_str) == 0) return Message({ message: "请输入表情包ID！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.zh == "") return Message({ message: "请输入表情包贴图名称(中文)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.en == "") return Message({ message: "请输入表情包贴图名称(英文)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.id == "") return Message({ message: "请输入表情包贴图名称(印尼)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.tw == "") return Message({ message: "请输入表情包贴图名称(繁体)！", type: "error", duration: 5 * 1000 });

    //显示等待
    this.dialogLoading = true;

    //数据赋值
    this.addForm.image = GFunc.checkstring(this.picUrl);
    this.addForm.sort = GFunc.checkint(this.addForm.sort_str);
    this.addForm.prop_id = GFunc.checkint(this.addForm.prop_id_str);

    //添加资源
    await propStickerSave(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏对话框
    this.dialogVisible = false;

    //获取数据
    this.getList();

    //显示提示
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });
  }

  //更新
  private async updateData() {
    //判断显示
    if (this.picUrl == "") return Message({ message: "请选择表情包贴图图片", type: "error", duration: 5 * 1000 });
    if (Number(this.addForm.sort_str) == 0) return Message({ message: "请输入排序！", type: "error", duration: 5 * 1000 });
    if (Number(this.addForm.prop_id_str) == 0) return Message({ message: "请输入表情包ID！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.zh == "") return Message({ message: "请输入表情包贴图名称(中文)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.en == "") return Message({ message: "请输入表情包贴图名称(英文)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.id == "") return Message({ message: "请输入表情包贴图名称(印尼)！", type: "error", duration: 5 * 1000 });
    if (this.addForm.name_list.tw == "") return Message({ message: "请输入表情包贴图名称(繁体)！", type: "error", duration: 5 * 1000 });

    //显示等待
    this.dialogLoading = true;

    //数据赋值
    this.addForm.image = GFunc.checkstring(this.picUrl);
    this.addForm.sort = GFunc.checkint(this.addForm.sort_str);
    this.addForm.prop_id = GFunc.checkint(this.addForm.prop_id_str);

    //添加资源
    await propStickerSave(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏对话框
    this.dialogVisible = false;

    //获取数据
    this.getList();

    //显示提示
    this.$notify({
      title: "成功",
      message: "更新成功",
      type: "success",
      duration: 2000,
    });
  }

  //是否创建
  private isCreate(): boolean {
    return this.dialogStatus === "create";
  }

  //--------------------------------- 图片处理 ---------------------------------
  //定义变量
  private picUrl: any = null;
  private picFileList: any[] = [];
  private getHeads = getHeaders();
  private getAction = this.getApi();

  //获取API
  private getApi(): string {
    const reg = /^https?\:\/\//;
    const baseApi = getAppBaseApi();
    const isMatch = reg.test(baseApi);
    const prefix = !isMatch ? window.location.origin : "";
    return `${prefix}${baseApi}/adm/picture/files`;
  }

  //图片动画预览
  private handlePicPreviewCommon(file: any): void {
    //数据赋值
    this.dialogImageUrl = file.url;

    //显示对话框
    this.dialogImageVisible = true;
  }

  //上传文件
  private handlePicBeforeUploadCommon(file: any): any {
    //数据赋值
    const index = file.name.lastIndexOf(".");
    const extension = file.name.substr(index + 1);
    const extensionList = ["png", "PNG", "jpg", "JPG", "jpeg", "JPEG", "gif", "svga", "mp4"];
    const isLt2M = file.size / 1024 / 1024 < 20;

    //文件过大
    if (!isLt2M) {
      //显示提示
      this.$notify({
        title: "失败",
        message: "图片或动画资源不可超出20M",
        type: "warning",
        duration: 2000,
      });

      //返回十八
      return false;
    }
    //格式不正确
    else if (extensionList.indexOf(extension) < 0) {
      this.$notify({
        title: "失败",
        message: "当前文件格式不支持",
        type: "error",
        duration: 2000,
      });
      return false;
    }
  }

  //移除图片
  private handlePicRemove(file: any, fileList: any): void {
    this.picUrl = null;
    this.picFileList = [];
  }

  //上传图片成功
  private handlePicUploadSuccess(response: any, file: any, fileList: any): void {
    //数据赋值
    this.picFileList = fileList;
    this.picUrl = response.data.images[0];
  }

  //--------------------------------- 显示图片 ---------------------------------
  //定义变量
  private dialogImageVisible = false;
  private dialogImageUrl: any = null;

  //打开图片
  private openImg(url: string) {
    //数据赋值
    this.dialogImageUrl = url;

    //显示界面
    this.dialogImageVisible = true;
  }
}
